module.exports = __webpack_public_path__ + "img/freeBuy6.1d69f455.png";